// Legacy code, edit with caution
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import BuilderControl from './contentbox/buildercontrol';
import { message } from 'antd';

export default class Editor extends Component {
  constructor(props) {
    super(props);
    this.onSave = this.onSave.bind(this);
    this.onSaveAndFinish = this.onSaveAndFinish.bind(this);
  }

  onSave(html, mainCss, sectionCss) {
    this.props.saveFn(html, mainCss, sectionCss);
  }

  async onSaveAndFinish(html, mainCss, sectionCss) {
    await this.props.saveFn(html, mainCss, sectionCss);
    await this.props.publishFn();
  }

  closeBuilder() {
    const answer = window.confirm('Do you really want to leave?');
    if (!answer) return false;

    this.props.onClose();
  }

  render() {
    return (
      <>
        <BuilderControl
          onSave={this.onSave}
          onSaveAndFinish={this.onSaveAndFinish}
          doSave={(f) =>
            (this.callSave = f)
          } /* https://stackoverflow.com/questions/37949981/call-child-method-from-parent */
          doSaveAndFinish={(f) => (this.callSaveAndFinish = f)}
          doObj={this.props.passUpObj}
        />

        <div
          className="is-ui"
          style={{
            position: 'fixed',
            right: '30px',
            bottom: '30px',
            display: 'flex',
            zIndex: 1,
          }}
        >
          <button
            type="button"
            onClick={() => {
              message.info('Processing...', 2);
              this.callSave();
            }}
            style={{ width: '85px' }}
          >
            Save
          </button>
          <button
            type="button"
            onClick={() => {
              message.info('Processing...', 2);
              this.callSaveAndFinish();
            }}
            style={{ width: '120px' }}
          >
            Save & Publish
          </button>
          <button
            type="button"
            onClick={() => this.closeBuilder()}
            style={{ width: '85px' }}
          >
            Close
          </button>
          <button
            type="button"
            onClick={() => {
              window.open('https://forms.gle/sQt8LRSHrhaQuqR67');
            }}
            style={{
              width: '100px',
              position: 'fixed',
              transform: 'rotate(-90deg) translateY(-50%)',
              transformOrigin: 'bottom right',
              backgroundColor: 'black',
              fontSize: '12px',
              fontWeight: '600',
              color: 'white',
              height: '43px',
              top: '35%',
              right: '-24px',
              borderRadius: '6px 6px 0 0',
            }}
          >
            Need Help
          </button>
        </div>
      </>
    );
  }
}
